/**
 * Order-insensitive identity of an activeFilters selection: which filters are
 * on, which values each has, and its match operator. Display strings, source /
 * target configs and anything else that can drift between sessions are ignored.
 */
const normaliseValues = (values) => {
  if (Array.isArray(values)) {
    return values.map((v) => (v && typeof v === "object" ? v.value : v)).sort();
  }
  return values ?? null; // number ranges: { min, max } / { exact }
};

export const activeFiltersSignature = (activeFilters = []) =>
  JSON.stringify(
    activeFilters
      .map((f) => ({
        filterId: f.filterId,
        values: normaliseValues(f.values),
        intraFilterOperator: f.intraFilterOperator ?? null,
        orGroupKey: f.orGroupKey ?? null,
      }))
      .sort((a, b) => (a.filterId > b.filterId ? 1 : a.filterId < b.filterId ? -1 : 0))
  );

/** The saved cohort whose filters equal the current selection, if any. */
export const findMatchingCohort = (cohorts = [], activeFilters = []) => {
  const current = activeFiltersSignature(activeFilters);
  return cohorts.find((c) => activeFiltersSignature(c.activeFilters) === current);
};
